import { render, staticRenderFns } from "./LineChartComercial.vue?vue&type=template&id=23206b50&"
import script from "./LineChartComercial.vue?vue&type=script&lang=js&"
export * from "./LineChartComercial.vue?vue&type=script&lang=js&"
import style0 from "./LineChartComercial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports